import DefaultLoader from "../../common/DefaultLoader";
import * as styles from "../styles";
import { Box } from "@mui/material";
import React from "react";

const DEFAULT_SIZE = 60;

export const LoadingOverlay = ({ color, size = DEFAULT_SIZE }) => (
  <Box sx={styles.centeredOverlay}>
    <DefaultLoader color={color} size={size} />
  </Box>
);

export const PageLoader = ({ color, size = 60 }) => (
  <Box
    sx={{
      width: "200px",
      height: "100px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginLeft: "auto",
      marginRight: "auto",
    }}
  >
    <DefaultLoader color={color} size={size} />
  </Box>
);

export default LoadingOverlay;
